<template>
	<RejectedCookiesAlert/>
	<toast-welcom></toast-welcom>
	<router-view></router-view>
	<InstallPrompt v-if="false"/>
	<CookieNotice></CookieNotice>
</template>

<script>
import ToastWelcom from "@/components/toastWelcom/ToastWelcom";
import InstallPrompt from './components/appInstallPrompt/AppInstallPrompt';
import CookieNotice from "@/components/utils/CookieNotice.vue";
import RejectedCookiesAlert from "@/components/utils/RejectedCookiesAlert.vue";

export default {
	name: 'App',
	components: {
		RejectedCookiesAlert,
		CookieNotice,
		ToastWelcom,
		InstallPrompt
	},
}
</script>
